// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__1wHcd","lastUpdated":"PrivacyPolicy_lastUpdated__3STzh"};